module.exports = {"TXTWCL_Converted_N0_to_N1":{"id":"TXTWCL_Converted_N0_to_N1","defaultMessage":"Конвертовано {0} у {1}"}}